import { queryClient } from "@/components/providers/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import type { FC, PropsWithChildren, ReactElement } from "react";

export const ReactQueryProvider: FC<PropsWithChildren> = ({ children }): ReactElement => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
